export const DEFAULT_TIMEOUT = 300000; // 5 minutes
// export const DEFAULT_TIMEOUT = 30000; // 30 seconds

export const MICRO_SERVICE_ROUTES = {
	NOTIFICATIONS: "/notifications",
	USERS: "/users",
};
export const API_ROUTES = {
	AUTH: `${MICRO_SERVICE_ROUTES.USERS}/auth/v1`,
	INSTITUTES: "/institutes",
	APPLICATIONS: "/applications",
	STUDENTS: "/students",
	TRACK_APPLICATIONS: "/applications/draft",
	TRACK_APPLICATIONS_STUDENTS: "/my-application",
	TRACK_APPLICATIONS_BY_ID: "/applications/draft",
	COURSES: "/courses",
	USERS: `${MICRO_SERVICE_ROUTES.USERS}/users/v1`,
	STUDENT_AUTH: "/users/users/v1/student",
	DISTRICT_BY_DIVISION: "/districts-by-division",
	LOCATIONS: "/locations",
	DIVISIONS: "/divisions",
	NOTIFICATIONS: `${MICRO_SERVICE_ROUTES.NOTIFICATIONS}/notifications`,
	DASHBOARD: "/dashboard",
	STUDENT_COURSES: "/student/courses",
	STUDENT_ENROLLED_COURSES: "/institutes/students/enrolled-courses",
	STUDENT_CERTIFIED_COURSE: "/institutes/students/certified-courses",
	STUDENT_OTP: "/users/auth/v1/student",
	STUDENT_COMPLETED_COURSES: "/institutes/students/completed-courses",
	STUDENT_APPLIED_COURSES: "/institutes/students/applied-courses",
	STUDENT_DROPOUT_COURSES: "/institutes/students/dropout-courses",
	STUDENT_MIGRATED_COURSES: "/institutes/students/migrated-courses",
	CBTA_COURSE_RESULT: (enrollmentUuid: string) =>
		`/institutes/cbta-course-result/enrollment/${enrollmentUuid}`,
	CONVENTIONAL_COURSE_RESULT: (enrollmentUuid: string) =>
		`/institutes/course-result/enrollment/${enrollmentUuid}`,
	ATTACHMENTS: "/institutes/attachments",
	ATTACHMENT_BY_KEY: (key: string) => {
		const normalizedKey = key.trim().replace(/^\/+/, "");
		return `${API_ROUTES.ATTACHMENTS}/${encodeURIComponent(normalizedKey)}`;
	},
	STUDENT_ATTENDANCE: (enrollmentId: string | number) => `/institutes/student-attendance/enrollments/${enrollmentId}`,
	STUDENT_LOGIN: "/users/auth/v1/student/login",
} as const;

export const API_PATHS = {
	AUTH: {
		SIGN_IN: "/login",
		SIGN_UP: "/email/register",
		VERIFY_EMAIL: "/verify-email",
		FORGOT_PASSWORD: "/forgot-password",
		RESET_PASSWORD: "/reset-password",
		CHANGE_PASSWORD: "/change-password",
		VERIFY_OTP: "/student/verify-otp",
		RESEND_OTP: "/student/resend-otp",
		REGISTRATION_RECOVERY_CHECK: "/student/registration-recovery/check",
		REGISTRATION_RECOVERY_UPDATE_EMAIL: "/student/registration-recovery/update-email",
		GENDERS: "/gender",
		RELIGIONS: "/religion",
		APPLICANT_TYPES: "/applicant-type",
		FEE_MODES: "/fee-mode",
		DISABILITIES: "/disability",
		ADMISSION_TYPES: "/admission-type",
		OCCUPATIONS: "/occupations",
		RELATIONSHIPS: "/relationships",
		INCOME_LEVELS: "/income-levels",
		DIVISIONS: "/divisions",
		DISTRICTS: "/districts",
		CITIES: "/cities",
		TEHSILS: "/tehsils",
		LEVELS: "/levels",
		VALIDATE: "/validate",
	},
	DASHBOARD: {
		METRICS: "/metrics",
		COURSES: "/courses",
		STATS: "/stats",
	},
	USER: {
		GET_PROFILE: "/profile",
		PROFILE_IMAGE_UPLOAD_URL: "/profile/image/upload-url",
		PROFILE_IMAGE_UPDATE: "/profile/image",
	},
	INSTITUTES: {
		APPLICATIONS: {
			INSTITUTE_DETAIL: "/applications/register",

			BUILDING_DETAIL: "/applications/building-detail",
			APPLICATION_ATTACHMENT: "/applications/application-attachment",
			SUBMIT: "/applications/{id}/submit",
			ADD_COURSE_STREAM: "/applications/{id}/add-course-stream",
		},
		ORGANIZATION_TYPE: "/organization-type",
		ORGANIZATION_CATEGORY: "/system/organization-category",
		PROVINCE: "/province",
		DIVISION: "/division",
		DISTRICT: "/district",
		CITY: "/city",
		TEHSIL: "/tehsil",
		SECTOR: "/sector",
		UNION_COUNCIL: "/union-council",
		NATIONAL_ASSEMBLY: "/national-assembly",
		PROVISIONAL_ASSEMBLY: "/provisional-assembly",
		FACILITY_TYPES: "/institutes/facility-types",
		ATTACHMENT_TYPES: "/institutes/attachment-types",
		FILE_UPLOAD_URL: "/attachments/upload",
		COURSE_STREAM: "/course-stream",
		COURSE_LIST: "/course",
		QUALIFICATION: "/qualification",
		QUALIFICATION_LEVEL_GROUPS: "/qualification/qualification-level-groups",
		DEGREE_TYPE: "/degree-type",
		DESIGNATION: "/designation",
		COURSE_LABS: "/labs/courses",
		ATTACHMENT_UPLOAD: "/attachments/upload",
		APPLICATION_COURSE: "/applications/application-course",
		APPLICATION_DRAFT: "/applications/draft",
		EMPLOYMENT_STATUS: "/employments/status",
		EMPLOYERS: "/employers",
		OUTCOME_JOB_TYPES: "/outcome-job-type",
		COUNTRY: "/country",
	},
	NOTIFICATIONS: {
		READ: "/read",
		STREAM: "/user/{id}/stream",
	},
	COURSES: {
		EQUIPMENT: "/equipment",
	},
};

export const SERVER_ROUTES = {
	AUTH: {
		SIGN_IN: API_ROUTES?.AUTH + API_PATHS?.AUTH?.SIGN_IN,
		SIGN_UP: API_ROUTES?.AUTH + API_PATHS?.AUTH?.SIGN_UP,
		VERIFY_EMAIL: API_ROUTES.AUTH + API_PATHS.AUTH.VERIFY_EMAIL,
		FORGOT_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.FORGOT_PASSWORD,
		RESET_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.RESET_PASSWORD,
		CHANGE_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.CHANGE_PASSWORD,
		VERIFY_OTP: API_ROUTES.AUTH + API_PATHS.AUTH.VERIFY_OTP,
		RESEND_OTP: API_ROUTES.AUTH + API_PATHS.AUTH.RESEND_OTP,
	},
	SIGNUP: {
		GENDERS: API_ROUTES.INSTITUTES + API_PATHS.AUTH.GENDERS,
		RELIGIONS: API_ROUTES.INSTITUTES + API_PATHS.AUTH.RELIGIONS,
		APPLICANT_TYPES: API_ROUTES.INSTITUTES + API_PATHS.AUTH.APPLICANT_TYPES,
		FEE_MODES: API_ROUTES.INSTITUTES + API_PATHS.AUTH.FEE_MODES,
		DISABILITIES: API_ROUTES.INSTITUTES + API_PATHS.AUTH.DISABILITIES,
		ADMISSION_TYPES: API_ROUTES.INSTITUTES + API_PATHS.AUTH.ADMISSION_TYPES,
		OCCUPATIONS: API_ROUTES.AUTH + API_PATHS.AUTH.OCCUPATIONS,
		RELATIONSHIPS: API_ROUTES.AUTH + API_PATHS.AUTH.RELATIONSHIPS,
		INCOME_LEVELS: API_ROUTES.AUTH + API_PATHS.AUTH.INCOME_LEVELS,
		DIVISIONS: API_ROUTES.AUTH + API_PATHS.AUTH.DIVISIONS,
		DISTRICTS: API_ROUTES.AUTH + API_PATHS.AUTH.DISTRICTS,
		CITIES: API_ROUTES.AUTH + API_PATHS.AUTH.CITIES,
		TEHSILS: API_ROUTES.AUTH + API_PATHS.AUTH.TEHSILS,
		LEVELS: API_ROUTES.AUTH + API_PATHS.AUTH.LEVELS,
	},
	DASHBOARD: {
		METRICS: API_ROUTES.DASHBOARD + API_PATHS.DASHBOARD.METRICS,
		COURSES: API_ROUTES.STUDENT_COURSES + API_PATHS.DASHBOARD.COURSES,
		STATS: API_ROUTES.INSTITUTES + "/students" + API_PATHS.DASHBOARD.STATS,
	},
	PAYMENT: {
		PAY_CHALLAN: API_ROUTES.INSTITUTES + "/applications/pay-challan",
	},
	USER: {
		GET_PROFILE: API_ROUTES.AUTH + API_PATHS.USER.GET_PROFILE,
		PROFILE_IMAGE_UPLOAD_URL: API_ROUTES.USERS + API_PATHS.USER.PROFILE_IMAGE_UPLOAD_URL,
		PROFILE_IMAGE_UPDATE: API_ROUTES.USERS + API_PATHS.USER.PROFILE_IMAGE_UPDATE,
		PROFILE_UPDATE: API_ROUTES.USERS + API_PATHS.USER.GET_PROFILE,
	},
	STUDENT: {
		VALIDATE: API_ROUTES.STUDENT_AUTH + API_PATHS.AUTH.VALIDATE,
		FORGOT_PASSWORD: API_ROUTES.STUDENT_OTP + API_PATHS.AUTH.FORGOT_PASSWORD,
		VERIFY_OTP: API_ROUTES.STUDENT_OTP + API_PATHS.AUTH.VERIFY_OTP,
		REGISTRATION_RECOVERY_CHECK: API_ROUTES.AUTH + API_PATHS.AUTH.REGISTRATION_RECOVERY_CHECK,
		REGISTRATION_RECOVERY_UPDATE_EMAIL: API_ROUTES.AUTH + API_PATHS.AUTH.REGISTRATION_RECOVERY_UPDATE_EMAIL,
		REGISTER: API_ROUTES.USERS + "/student/register",
		ADMISSION_FORM: API_ROUTES.USERS + "/student/admission-form",
		UPDATE_REGISTRATION: API_ROUTES.USERS + "/student/admission-form",
		GET_REGISTRATION: API_ROUTES.USERS + "/student/admission-form",
		SIGN_IN: API_ROUTES.STUDENT_LOGIN,
		ENROLLED_COURSES: (page: number = 1, limit: number = 10) =>
			`${API_ROUTES.STUDENT_ENROLLED_COURSES}?page=${page}&limit=${limit}`,
		ENROLLED_COURSE_DETAILS: (enrollmentId: string | number) =>
			`${API_ROUTES.INSTITUTES}/students/enrolled-courses/${enrollmentId}`,
		PROMOTION_HISTORY: (enrollmentUuid: string) =>
			`${API_ROUTES.INSTITUTES}/student-promotion/enrollment/${enrollmentUuid}/history`,
		CERTIFIED_COURSE: (uuid: string) => `${API_ROUTES.STUDENT_CERTIFIED_COURSE}/${uuid}`,
		COMPLETED_COURSES: (page: number = 1, limit: number = 10) =>
			`${API_ROUTES.STUDENT_COMPLETED_COURSES}?page=${page}&limit=${limit}`,
		APPLIED_COURSES: (page: number = 1, limit: number = 10) =>
			`${API_ROUTES.STUDENT_APPLIED_COURSES}?page=${page}&limit=${limit}`,
		DROPOUT_COURSES: (page: number = 1, limit: number = 10) =>
			`${API_ROUTES.STUDENT_DROPOUT_COURSES}?page=${page}&limit=${limit}`,
		DROPOUT_COURSE_DETAILS: (enrollmentId: string | number) =>
			`${API_ROUTES.STUDENT_DROPOUT_COURSES}/${enrollmentId}/dropout-details`,
		MIGRATED_COURSES: (page: number = 1, limit: number = 10) =>
			`${API_ROUTES.STUDENT_MIGRATED_COURSES}?page=${page}&limit=${limit}`,
		MY_APPLICATIONS: `${API_ROUTES.INSTITUTES}${API_ROUTES.STUDENTS}${API_ROUTES.TRACK_APPLICATIONS_STUDENTS}`,
		CBTA_COURSE_RESULT: (enrollmentUuid: string) => API_ROUTES.CBTA_COURSE_RESULT(enrollmentUuid),
		CONVENTIONAL_COURSE_RESULT: (enrollmentUuid: string) => API_ROUTES.CONVENTIONAL_COURSE_RESULT(enrollmentUuid),
		SESSION_STUDENT_MY_RESULT: (enrollmentUuid: string) =>
			`${API_ROUTES.INSTITUTES}/session-students/me/enrollments/${enrollmentUuid}/result`,
		OUTCOME: `${API_ROUTES.INSTITUTES}/students/me/outcome`,
		OUTCOME_CURRENT: `${API_ROUTES.INSTITUTES}/students/me/outcome/current`,
		EMPLOYMENTS: `${API_ROUTES.INSTITUTES}/students/me/employments`,
		EMPLOYMENT_BY_UUID: (uuid: string) => `${API_ROUTES.INSTITUTES}/students/me/employments/${uuid}`,
	},

	ATTACHMENTS: {
		GET_PRESIGNED_URL: (filename: string) => {
			const normalizedKey = filename.trim().replace(/^\/+/, "");
			return `${API_ROUTES.ATTACHMENTS}/${encodeURIComponent(normalizedKey)}`;
		},
	},
	INSTITUTES: {
		APPLICATIONS: {
			INSTITUTE_DETAIL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.INSTITUTE_DETAIL,
			BUILDING_DETAIL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.BUILDING_DETAIL,
			APPLICATION_ATTACHMENT: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.APPLICATION_ATTACHMENT,
			SUBMIT: (id: number) => `${API_ROUTES.INSTITUTES}/applications/${id}/submit`,
			ADD_COURSE_STREAM: (id: number) => `${API_ROUTES.INSTITUTES}/applications/${id}/add-course-stream`,
		},
		ORGANIZATION_TYPE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.ORGANIZATION_TYPE,
		ORGANIZATION_CATEGORY: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.ORGANIZATION_CATEGORY,
		PROVINCE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.PROVINCE,
		DIVISION: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.DIVISION,
		DISTRICT: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.DISTRICT,
		CITY: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.CITY,
		TEHSIL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.TEHSIL,
		SECTOR: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.SECTOR,
		TECHNOLOGY: API_ROUTES.INSTITUTES + "/technology",
		ADMISSION_QUOTA: API_ROUTES.INSTITUTES + "/admission-quota",
		UNION_COUNCIL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.UNION_COUNCIL,
		NATIONAL_ASSEMBLY: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.NATIONAL_ASSEMBLY,
		PROVISIONAL_ASSEMBLY: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.PROVISIONAL_ASSEMBLY,
		FACILITY_TYPES: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.FACILITY_TYPES,
		ATTACHMENT_TYPES: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.ATTACHMENT_TYPES,
		FILE_UPLOAD_URL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.FILE_UPLOAD_URL,
		COURSE_STREAM: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.COURSE_STREAM,
		COURSE_LIST: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.COURSE_LIST,
		QUALIFICATION: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.QUALIFICATION,
		QUALIFICATION_LEVEL_GROUPS: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.QUALIFICATION_LEVEL_GROUPS,
		DEGREE_TYPE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.DEGREE_TYPE,
		DESIGNATION: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.DESIGNATION,
		COURSE_LABS: (courseId: string) => `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.COURSE_LABS}/${courseId}/labs`,
		ATTACHMENT_UPLOAD: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.ATTACHMENT_UPLOAD,
		APPLICATION_COURSE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATION_COURSE,
		DRAFT_APPLICATIONS: (limit: number, page: number) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATION_DRAFT}?limit=${limit}&page=${page}`,
		CERTIFIED_COURSES_FILTER: API_ROUTES.INSTITUTES + "/students/certified-courses-by-institutes",
		CERTIFIED_COURSE_DETAILS: (uuid: string) => `${API_ROUTES.INSTITUTES}/students/certified-courses/${uuid}`,
		USED_PREFERENCES: (instituteUuid: string) => `${API_ROUTES.INSTITUTES}/students/used-preferences?instituteUuid=${instituteUuid}`,
		APPLY_COURSE: API_ROUTES.INSTITUTES + "/students/apply-course",
		STUDENT_SKILLS: API_ROUTES.INSTITUTES + "/student-skill",
		EMPLOYMENT_STATUS: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.EMPLOYMENT_STATUS,
		HIGHER_STUDY: `${API_ROUTES.INSTITUTES}/higher-study`,
		HIGHER_STUDY_BY_UUID: (uuid: string) => `${API_ROUTES.INSTITUTES}/higher-study/${uuid}`,
		EMPLOYERS: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.EMPLOYERS}`,
		OUTCOME_JOB_TYPES: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.OUTCOME_JOB_TYPES}`,
		COUNTRY: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.COUNTRY}`,
	},
	COURSES: {
		COURSES: API_ROUTES.COURSES,
		EQUIPMENT: (courseId: string) => `${API_ROUTES.COURSES}/${courseId}${API_PATHS.COURSES.EQUIPMENT}`,
	},

	APPLICATIONS: {
		APPLICATIONS: API_ROUTES.APPLICATIONS,
	},

	TRACK_APPLICATIONS: {
		TRACK_APPLICATIONS_BYID: API_ROUTES.INSTITUTES + `${API_ROUTES.TRACK_APPLICATIONS_BY_ID}`,
		GET_LIST_OF_TRACK_APPLICATIONS:
			API_ROUTES.INSTITUTES + API_ROUTES.STUDENTS + API_ROUTES.TRACK_APPLICATIONS_STUDENTS,
		TRACK_APPLICATION: (id: string | number) =>
			`${API_ROUTES.INSTITUTES}/${API_ROUTES.STUDENTS}/application-track/${id}`,
		ACCEPT_ADMISSION: (id: string | number) => `${API_ROUTES.INSTITUTES}/students/applications/${id}/accept-admission`,
		DECLINE_ADMISSION: (id: string | number) =>
			`${API_ROUTES.INSTITUTES}/students/applications/${id}/decline-admission`,
		APPLICATION_STATUSES: `${API_ROUTES.INSTITUTES}/students/application-statuses`,
	},
	NOTIFICATIONS: {
		NOTIFICATIONS: API_ROUTES.NOTIFICATIONS,
		READ: (id: string) => `${API_ROUTES.NOTIFICATIONS}/${id}${API_PATHS.NOTIFICATIONS.READ}`,
		STREAM: (id: string) => `${API_ROUTES.NOTIFICATIONS}/${API_PATHS.NOTIFICATIONS.STREAM.replace("{id}", id)}`,
	},
	JOBS: {
		JOBS_LIST: API_ROUTES.INSTITUTES + "/job-applications/match-job-candidates",
		EXPERIENCES: API_ROUTES.INSTITUTES + "/experience",
		SKILLS: API_ROUTES.INSTITUTES + "/skill",
		JOB_APPLICATIONS: API_ROUTES.INSTITUTES + "/job-applications",
		EMPLOYMENT_TYPES: API_ROUTES.INSTITUTES + "/employment-type",
		SECTORS: API_ROUTES.INSTITUTES + "/sector",
		TRADES: (page: number = 1, limit: number = 20) => 
			`${API_ROUTES.INSTITUTES}/course?page=${page}&limit=${limit}`,
	},
	FAQ: {
		FAQ_SECTIONS: API_ROUTES.INSTITUTES + "/faq-sections",
		FAQ_SECTIONS_WITH_ITEMS: API_ROUTES.INSTITUTES + "/faq-sections/faqs",
		FAQ_ITEMS: API_ROUTES.INSTITUTES + "/faq-items",
		FAQ_ITEMS_BY_SECTION: (sectionId: number) => `${API_ROUTES.INSTITUTES}/faq-items/section/${sectionId}`,
	},
} as const;

export const QUERY_KEYS = {
	USER: {
		PROFILE_IMAGE_UPDATE: "profile-image-update",
		PROFILE_UPDATE: "profile-update",
		GET_PROFILE: "profile",
	},
	STUDENT: {
		ENROLLED_COURSES: "enrolled-courses",
		ENROLLED_COURSE_DETAILS: "enrolled-course-details",
		PROMOTION_HISTORY: "promotion-history",
		CERTIFIED_COURSE: "certified-course",
		COMPLETED_COURSES: "completed-courses",
		APPLIED_COURSES: "applied-courses",
		DROPOUT_COURSES: "dropout-courses",
		DROPOUT_COURSE_DETAILS: "dropout-course-details",
		MIGRATED_COURSES: "migrated-courses",
		ATTENDANCE: "student-attendance",
		GET_REGISTRATION: "student-registration",
	},
	ATTACHMENTS: {
		PRESIGNED_URL: "presigned-url",
		ATTACHMENT_BY_KEY: "attachment-by-key",
	},
	SIGNUP: {
		GENDERS: "genders",
		RELIGIONS: "religions",
		APPLICANT_TYPES: "applicant-types",
		FEE_MODES: "fee-modes",
		DISABILITIES: "disabilities",
		MARITAL_STATUSES: "marital-statuses",
		ADMISSION_TYPES: "admission-types",
		OCCUPATIONS: "occupations",
		RELATIONSHIPS: "relationships",
		INCOME_LEVELS: "income-levels",
		DIVISIONS: "divisions",
		DISTRICTS: "districts",
		CITIES: "cities",
		TEHSILS: "tehsils",
		LEVELS: "levels",
	},
	DASHBOARD: {
		METRICS: "dashboard-metrics",
		COURSES: "dashboard-courses",
		STATS: "dashboard-stats",
	},
	COURSES: {
		COURSES: "courses",
		EQUIPMENT: "course-equipment",
	},

	APPLICATIONS: {
		APPLICATIONS: "applications",
	},

	MY_RESULTS: {
		APPLICATIONS: "my-results-applications",
		COURSE_RESULT: "my-results-course-result",
	},
	TRACK_APPLICATIONS: {
		TRACK_APPLICATIONS: "track-applications",
		ACCEPT_ADMISSION: "accept-admission",
		DECLINE_ADMISSION: "decline-admission",
		APPLICATION_STATUSES: "application-statuses",
	},
	INSTITUTES: {
		ORGANIZATION_TYPE: "organization-types",
		ORGANIZATION_CATEGORY: "organization-categories",
		PROVINCE: "provinces",
		DIVISION: "divisions",
		DISTRICT: "districts",
		CITY: "cities",
		TEHSIL: "tehsils",
		COURSE_STREAM: "course-stream",
		COURSE_LIST: "course-list",
		SECTOR: "sectors",
		QUALIFICATION_LEVEL_GROUPS: "qualification-level-groups",
		DEGREE_TYPE: "degree-type",
	},
	JOBS: {
		JOBS_LIST: "jobs-list",
		EXPERIENCES: "experiences",
		SKILLS: "skills",
		JOB_APPLICATIONS: "job-applications",
		EMPLOYMENT_TYPES: "employment-types",
		SECTORS: "job-sectors",
		TRADES: "job-trades",
	},
	STATUS: {
		EMPLOYMENT_STATUSES: "employment-statuses",
		EMPLOYMENT_ACTIVITY: "employment-activity",
		OUTCOME_CURRENT: "outcome-current",
		HIGHER_STUDY: "higher-study",
		EMPLOYERS: "status-employers",
		OUTCOME_JOB_TYPES: "status-outcome-job-types",
		COUNTRIES: "status-countries",
		DISTRICTS: "status-districts",
		CITIES: "status-cities",
	},
	FAQ: {
		SECTIONS: "faq-sections",
		SECTIONS_WITH_ITEMS: "faq-sections-with-items",
		ITEMS: "faq-items",
	},
};
export const QUERY_PARAMS = {};

export const AUTH_ENDPOINTS = [
	SERVER_ROUTES.AUTH.SIGN_IN,
	SERVER_ROUTES.AUTH.SIGN_UP,
	SERVER_ROUTES.AUTH.FORGOT_PASSWORD,
	SERVER_ROUTES.AUTH.RESET_PASSWORD,
	SERVER_ROUTES.AUTH.VERIFY_OTP,
	SERVER_ROUTES.AUTH.RESEND_OTP,
	SERVER_ROUTES.AUTH.VERIFY_EMAIL,
	SERVER_ROUTES.STUDENT.SIGN_IN, // Add student login endpoint
	SERVER_ROUTES.STUDENT.VERIFY_OTP, // Add student verify OTP endpoint
	SERVER_ROUTES.STUDENT.FORGOT_PASSWORD,
	SERVER_ROUTES.STUDENT.REGISTER, // Add student register endpoint
	SERVER_ROUTES.STUDENT.UPDATE_REGISTRATION, // Add student update registration endpoint
	SERVER_ROUTES.STUDENT.GET_REGISTRATION, // Add student get registration endpoint
	SERVER_ROUTES.STUDENT.VALIDATE, // Add student validate endpoint
	SERVER_ROUTES.STUDENT.REGISTRATION_RECOVERY_CHECK,
	SERVER_ROUTES.STUDENT.REGISTRATION_RECOVERY_UPDATE_EMAIL,
];
